import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      textAlign: "center",
      [theme.breakpoints.up("mobile")]: {
        padding: "0 134px",
      },
    },
    title: {
      marginBottom: 35,
    },
  }),
  { name: "CategoryFooter" },
);
